// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BootstrapLoader-module__container___lrsaX{display:flex;justify-content:center;align-items:center;height:100vh}`, "",{"version":3,"sources":["webpack://./BootstrapLoader.module.scss"],"names":[],"mappings":"AAAA,2CACE,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,YAAA","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BootstrapLoader-module__container___lrsaX`
};
export default ___CSS_LOADER_EXPORT___;
